import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vi-loader',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule],
  templateUrl: 'loader.component.html',
  styleUrls: ['loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViLoaderComponent {
  @Input() isLoading: boolean;
  @Input() message: string = 'GENERAL.DATA_IS_LOADING';
  @Input() titleKey: string = 'GENERAL.LOADING';
  @Input() viOrangeTheme: boolean = false;
  @Input() size: 'normal' | 'large' = 'normal';
}
